import request from "@/services/request";
import baseUrl from "@/services/baseUrl";

// this is for globally used APIs only
const feeURL = baseUrl.main + "/fapi/fee/";
const userV2URL = baseUrl.main + "/fapi/userv2/";

export default {
    getCurrencies: (param = {}) => request.get(feeURL + "currencies"),
    getSupportedCurrencies: (param = {}) => request.get(userV2URL + "supported-currencies"),
}

